﻿/**
* DevExpress Analytics (diagram\elements\diagramElementModel.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var elementViewModel_1 = require("../../core/elements/elementViewModel");
var utils_1 = require("../../serializer/utils");
var metadata_1 = require("../metadata");
var _utils_1 = require("../../serializer/_utils");
var DiagramElementBaseViewModel = (function (_super) {
    __extends(DiagramElementBaseViewModel, _super);
    function DiagramElementBaseViewModel(control, parent, serializer) {
        return _super.call(this, control, parent, serializer) || this;
    }
    DiagramElementBaseViewModel.prototype.getControlFactory = function () {
        return controlsFactory_1.diagramControlsFactory;
    };
    return DiagramElementBaseViewModel;
}(elementViewModel_1.ElementViewModel));
exports.DiagramElementBaseViewModel = DiagramElementBaseViewModel;
var DiagramElementViewModel = (function (_super) {
    __extends(DiagramElementViewModel, _super);
    function DiagramElementViewModel(control, parent, serializer) {
        var _this = _super.call(this, _utils_1.extend({ '@ControlType': 'DiagramElement' }, control), parent, serializer) || this;
        _this.connectingPoints = utils_1.deserializeArray(control && control.ConnectingPoints || [], function (item) { return new connectingPointModel_1.ConnectingPointViewModel(item, _this, serializer); });
        if (_this.text() === undefined) {
            _this.text(_this.name());
        }
        return _this;
    }
    return DiagramElementViewModel;
}(DiagramElementBaseViewModel));
exports.DiagramElementViewModel = DiagramElementViewModel;
exports.diagramElementSerializationInfo = [metadata_1.size, metadata_1.location, metadata_1.name, metadata_1.text, { propertyName: 'type', modelName: '@Type' }];
var connectingPointModel_1 = require("./connectingPointModel");
var controlsFactory_1 = require("../controlsFactory");
